// extracted by mini-css-extract-plugin
export default {"uploadButton":"UploadResumeButton_uploadButton__kMcis"};